var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      attrs: {
        error: _vm.errors.has("currency"),
        "error-label": _vm.errors.first("currency"),
        label: !_vm.floatingLabel ? _vm.label : null,
        labelWidth: _vm.labelWidth
      }
    },
    [
      _c("q-select", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate.disable",
            value: "required|currency",
            expression: "'required|currency'",
            modifiers: { disable: true }
          }
        ],
        attrs: {
          "data-vv-name": "currency",
          "float-label": _vm.floatingLabel ? _vm.label : null,
          placeholder: _vm.$t("currency"),
          options: _vm.currencyOptions,
          value: _vm.value,
          disable: _vm.disable
        },
        on: { input: _vm._emit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }